import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import App from "./App";
// import Dashboard from "./Views/Web/Dashboard";
import Auth from "./Views/Main/MainAuth";
// import Login from "./Views/Web/Auth/login";
import PageNotFound from "./Components/Utils/PageNotFound";
import PrivateRoute from "./Services/PrivateRouter";
// import PageLoader from "./Components/Utils/PageLoader";
import {
  DashboardRoutes,
  MaintenanceRoutes,
  MarketingRoutes,
  PaymentRoutes,
  ProcurementRoutes,
  ProductRoutes,
  ReportRoutes,
  SalesRoutes,
  SettingsRoutes,
  ShippingRoutes,
  StoreRoutes,
  TaskRoutes,
  MeetingRoutes,
} from "./Routes";
import { GetDashboardRole, Wrapper } from "./Components/Utils/roles";

import MainChat from "./Views/Web/chat/chatMain";
import ChatProfile from "./Views/Web/chat/chatProfile";
import ChatIndex from "./Views/Web/chat";
import ChangePassword from "./Views/Web/Auth/login/changePassword";
import AnotherLogin from "./Views/Web/Auth/login/AnotherIndex";
import UserProfile from "./Views/Web/Profile/userProfile";
import EditUserprofile from "./Views/Web/Profile/EditUserprofile";
import MainProfile from "./Views/Web/Profile/MainProfile";
import ChangeUserPassword from "./Views/Web/Profile/ChangeUserPassword";
import NotificationProfile from "./Views/Web/Profile/NotificationProfile";
import Maintenance from "./Views/Web/Auth/Maintenance";
import AgeingAnalysisIndex from "./Views/Web/Payment/AgeingAnalysis";

function Mainroutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMaintenance, setIsMaintenance] = useState(false);
  // const isSuperAdmin = GetSuperAdminRole();

  // UNDER MAINTENANCE LOGIC TEMPORARILY DISABLED (disabled repeated API calls)
  // useEffect(() => {
  //   const fetchStatus = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${window.WEB_APP_API_URL}/auth/maintenance-status`,
  //       );
  //       setIsMaintenance(response.data?.isMaintenanceMode || false);
  //     } catch (error) {
  //       console.error("Error checking maintenance status in routes:", error);
  //     }
  //   };
  //   fetchStatus();
  //   const interval = setInterval(fetchStatus, 30000);
  //   return () => clearInterval(interval);
  // }, []);

  // useEffect(() => {
  //   if (isSuperAdmin && location.pathname === "/under-maintenance") {
  //     navigate("/", { replace: true });
  //     return;
  //   }
  //
  //   if (isSuperAdmin) return;
  //
  //   if (isMaintenance && location.pathname !== "/under-maintenance") {
  //     navigate("/under-maintenance", { replace: true });
  //   } else if (!isMaintenance && location.pathname === "/under-maintenance") {
  //     navigate("/", { replace: true });
  //   }
  // }, [isMaintenance, location.pathname, navigate, isSuperAdmin]);

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === "" ||
      location.pathname === "/main"
    ) {
      const isSales = GetDashboardRole("sales") || GetDashboardRole("sales man");
      const isProcurement = GetDashboardRole("procurement");
      const isStore = GetDashboardRole("store");
      const isAdmin = GetDashboardRole(""); // admin or super admin

      let dashboardPath = "/dashboard";
      if (!isAdmin) {
        if (isSales) dashboardPath = "/dashboard/sales";
        else if (isProcurement) dashboardPath = "/dashboard/procurement";
        else if (isStore) dashboardPath = "/dashboard/stores";
      }

      navigate(dashboardPath, { replace: true });
    }
    if (location.pathname === "/auth") {
      navigate("/auth/login", { replace: true });
    }
    if (location.pathname === "/chat") {
      navigate("/chat/view");
    }
  }, [location, isMaintenance]);

  return (
    <Routes>
      <Route path="/under-maintenance" element={<Maintenance setIsMaintenance={setIsMaintenance} />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <App />
          </PrivateRoute>
        }
      >
        {DashboardRoutes()}
        {ProductRoutes()}
        {ShippingRoutes()}
        {SalesRoutes()}
        {ProcurementRoutes()}
        {StoreRoutes()}
        {MarketingRoutes()}
        {PaymentRoutes()}
        {MaintenanceRoutes()}
        {MeetingRoutes()}
        {TaskRoutes()}
        {ReportRoutes()}
        <Route
          path="ageing-analysis"
          element={
            <Wrapper
              permissionKey={"ageing_analysis_view"}
              Component={AgeingAnalysisIndex}
            />
          }
        />
        <Route path="chat" element={<MainChat />}>
          <Route path="view" element={<ChatIndex />}>
            <Route path="chatProfile/:chatID" element={<ChatProfile />} />
          </Route>
        </Route>
        {/* <Route path="chat-screen" element={<MainChat/>} >
          <Route path="" element={<ChatIndexScreen/>} >
             <Route path="chat-profile/:chatProfileId" element={<ChatProfileScreen/>}/>
          </Route>
        </Route> */}
        <Route path="/profile" element={<MainProfile />}>
          <Route index element={<UserProfile />} />
          <Route path="editProfile/:profileid" element={<EditUserprofile />} />
          <Route
            path="PasswordProfile/:Passwordid"
            element={<ChangeUserPassword />}
          />
          <Route
            path="notificationProfile/:userId"
            element={<NotificationProfile />}
          />
        </Route>
      </Route>
      <Route path="/auth" element={<Auth />}>
        <Route path="login" element={<AnotherLogin />} />
        <Route path="forget-password" element={<ChangePassword />} />
      </Route>
      {SettingsRoutes()}
      <Route path="*" element={<PageNotFound />} />
      <Route
        path="page-not-found"
        element={<PageNotFound backbutton={false} />}
      />
    </Routes>
  );
}

export default Mainroutes;
